import Button from "components/components/Button/Button";
import styled from "styled-components";

export const GranularityButton = styled(Button)`
  width: 95px !important;
`;
